const en = {
    'scheduledcommand.table.title': 'Command Scheduling',
    'scheduledcommand.table.button.create': 'Create Task',
    'scheduledcommand.table.description': 'Description',
    'scheduledcommand.table.command': 'Command',
    'scheduledcommand.table.arguments': 'Arguments',
    'scheduledcommand.table.cronExpression': 'Cron Expression',
    'scheduledcommand.table.lastExecution': 'Last Execution',
    'scheduledcommand.table.lastReturnCode': 'Last Return Code',
    'scheduledcommand.table.lastOutput': 'Last Output',
    'scheduledcommand.table.status': 'Status',
    'scheduledcommand.table.running': 'Running',
    'scheduledcommand.table.actions': 'Actions',
    'scheduledcommand.table.lastOutput.show': 'Show Output',
    'scheduledcommand.table.lastOutput.title': 'Last Execution Output',
    'scheduledcommand.table.lastOutput.close': 'Close',
    'scheduledcommand.table.enabled': 'Enabled',
    'scheduledcommand.table.disabled': 'Disabled',
    'scheduledcommand.table.notRunning': 'Not Running',
    'scheduledcommand.table.enable': 'Enable',
    'scheduledcommand.table.disable': 'Disable',
    'scheduledcommand.table.run.title': 'Run Task',
    'scheduledcommand.table.run.phrase': 'Are you sure you want to run the task?',
    'scheduledcommand.table.run.cancel': 'Cancel',
    'scheduledcommand.table.run.run': 'Confirm',
    'scheduledcommand.table.disable.title': 'Disable Task',
    'scheduledcommand.table.disable.phrase': 'Are you sure you want to disable the task?',
    'scheduledcommand.table.disable.cancel': 'Cancel',
    'scheduledcommand.table.disable.disable': 'Confirm',
    'scheduledcommand.table.enable.title': 'Enable Task',
    'scheduledcommand.table.enable.phrase': 'Are you sure you want to enable the task?',
    'scheduledcommand.table.enable.cancel': 'Cancel',
    'scheduledcommand.table.enable.enable': 'Confirm',
    'scheduledcommand.table.delete.title': 'Delete Task',
    'scheduledcommand.table.delete.phrase': 'Are you sure you want to delete the task?',
    'scheduledcommand.table.delete.cancel': 'Cancel',
    'scheduledcommand.table.delete.delete': 'Confirm',

    'scheduledcommand.form.create': 'Create Task',
    'scheduledcommand.form.update': 'Update Task',
    'scheduledcommand.form.cancel': 'Cancel',
    'scheduledcommand.form.description': 'Description',
    'scheduledcommand.form.command': 'Command',
    'scheduledcommand.form.arguments': 'Arguments',
    'scheduledcommand.form.cronExpression': 'Cron Expression',
    'scheduledcommand.form.disabled': 'Disabled',
};

export default en;